import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const zSensorForm = z.object({
    reference: z
        .string()
        .max(50, {
            message: 'La référence du capteur doit comporter au maximum 50 caractères.',
        })
        .optional(),
    label: z
        .string()
        .nonempty({ message: 'Le libellé est requis.' })
        .max(100, { message: 'Le libellé doit comporter au maximum 100 caractères.' }),
    description: z
        .string()
        .max(500, {
            message: 'La description doit comporter au maximum 500 caractères.',
        })
        .optional(),
    model: z
        .string()
        .max(100, { message: 'Le modèle doit comporter au maximum 100 caractères.' })
        .nullable()
        .optional()
        .transform((val) => val || ''),
    fridgeId: z.number({ required_error: 'Le réfrigérateur est requis.' }),
});

export type SensorForm = z.infer<typeof zSensorForm>;

// Form hook
export const useSensorForm = (defaultValues?: Partial<SensorForm>) => {
    const form = useForm<SensorForm>({
        // Validation function
        resolver: zodResolver(zSensorForm),
        defaultValues: {
            reference: '',
            label: '',
            description: '',
            model: '',
            fridgeId: undefined,
            ...defaultValues,
        },
    });

    return form;
};
